export default "__VITE_ASSET__BbC1s0k3__"